// Part quantities are decimals (4.5 L of oil, 0.25 h of shop supplies).
// Money is rounded to cents once per line, half up, in integer cents so that
// 4.5 x 9.99 (44.955 in decimal, 44.954999... in binary) gives 44.96.

// A positive finite number, or '' while the field is empty or not a number.
export const parseQuantity = (value) => {
  if (value === '' || value === null || value === undefined) return '';
  const n = typeof value === 'number' ? value : parseFloat(value);
  if (!Number.isFinite(n)) return '';
  // 2 decimals, half up, so pricing uses what the screen shows (0.333 -> 0.33).
  const rounded = Math.round(Number((n * 100).toPrecision(12))) / 100;
  return rounded > 0 ? rounded : '';
};

// What totals and the save payload use: an empty, zero or invalid quantity is 1.
export const effectiveQuantity = (value) => parseQuantity(value) || 1;

export const formatQuantity = (q) => {
  const n = effectiveQuantity(q);
  return String(Number(n.toFixed(2)));
};

export const lineTotal = (q, unitCost) => {
  const cents = effectiveQuantity(q) * (parseFloat(unitCost) || 0) * 100;
  // toPrecision(12) strips binary noise (4495.5 vs 4495.499999...) before rounding.
  return Math.round(Number(cents.toPrecision(12))) / 100;
};
